/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-10-25 16:05:26
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\CustomerStoreAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

const CustomerStoreAPI = {

  getAllCustomerWithStores: async () => {
    try {
      const url = `${getBizCode()}/customers`
      const res = await AM_API.get(url)
      console.log('getAll res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      console.log('getAll cate fail...', e)
      throw e
    }
  },

  getCustomerList: async () => {
    try {
      const url = `${getBizCode()}/customers?get_customer_list`
      const res = await AM_API.get(url)
      console.log('getAll res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      console.log('getAll cate fail...', e)
      throw e
    }
  },
  addStore: async (payload: any) => {
    try {
      const url = `${getBizCode()}/customers`
      const res = await AM_API({
        url,
        method: "POST",
        data: payload
      })
      console.log('addStore res', res)
      return res
    } catch (e) {
      logError(e)
      console.log('addStore cate fail...', e)
      throw e
    }
  },
  updateStore: async (payload: any) => {
    try {
      const url = `${getBizCode()}/customers`
      const res = await AM_API({
        url,
        method: "PUT",
        data: payload
      })
      console.log('updateStore res', res)
      return res
    } catch (e) {
      logError(e)
      console.log('updateStore cate fail...', e)
      throw e
    }
  },
  deleteStore: async (customer_ID: string, store_ID: string) => {
    try {
      const url = `${getBizCode()}/customers?customer_ID=${customer_ID}&store_ID=${store_ID}`
      const res = await AM_API.delete(url)
      console.log('getAll res', res)
      return res
    } catch (e) {
      logError(e)
      console.log('getAll cate fail...', e)
      throw e
    }
  },

}

export default CustomerStoreAPI